import { LegendFlex as ChartLegend } from './LegendFlex/LegendFlex';
import { LegendTable as ChartLegendTable } from './LegendTable/LegendTable';

export { ChartLegend, ChartLegendTable };

export default ChartLegend;
